import { Component } from '@angular/core';
import { IAtermarketEquipment } from '@impact/data';

import { BreakpointService } from '../../../../../breakpoint/breakpoint.service';
import { CheckoutService } from '../../../../../checkout/checkout.service';

@Component({
    selector: 'app-aftermarket-equipment',
    template: `
        <ng-container *ngIf="checkoutService.getCheckoutData() | async as cd">
            [app-aftermarket-equipment]
            <ng-container *ngIf="cd.equipment?.length">
                <section class="summary summary--active" *ngIf="cd.equipment" appCircleCheckmark [condition]="true">
                    <div class="summary__header">
                        <h3 class="h5 no-margin">
                            {{ 'checkout.summary_step____aftermarket_equipment____headline' | translate }}
                        </h3>
                    </div>
                    <div class="summary__content text-small">
                        <div
                            class="unstyled-table unstyled-table--first-child-bold"
                            [class.unstyled-table--first-child-wide]="cd.offer?.closedOnExchangePrice"
                            role="table"
                        >
                            <div *ngFor="let equipment of cd.equipment" class="unstyled-table__row" role="row">
                                <div class="unstyled-table__cell" role="cell">{{ equipment.name }}</div>
                                <ng-container *ngIf="!cd.offer?.closedOnExchangePrice">
                                    <ng-container *ngIf="!!(breakpointService.matchBreakpoint(1024) | async)">
                                        <div class="unstyled-table__cell" role="cell">
                                            <app-button
                                                buttonClass="button--mini equipment-button"
                                                (handleClick)="handleClick(cd.equipment, equipment, !equipment.enabled)"
                                                [loading]="!!(checkoutService.aftermarketEquipmentLoading$ | async)"
                                                [title]="
                                                    (equipment.enabled
                                                        ? 'checkout.summary_step____aftermarket_equipment____disable_equipment_line'
                                                        : 'checkout.summary_step____aftermarket_equipment____enable_equipment_line'
                                                    ) | translate
                                                "
                                            ></app-button>
                                        </div>
                                    </ng-container>
                                    <div class="unstyled-table__cell" role="cell">
                                        <div>{{ equipment.priceInclWat | defaultcurrency }}</div>
                                        <ng-container *ngIf="(breakpointService.matchBreakpoint(1024) | async) === false">
                                            <app-button
                                                buttonClass="button--mini equipment-button"
                                                (handleClick)="handleClick(cd.equipment, equipment, !equipment.enabled)"
                                                [loading]="!!(checkoutService.aftermarketEquipmentLoading$ | async)"
                                                [title]="
                                                    (equipment.enabled
                                                        ? 'checkout.summary_step____aftermarket_equipment____disable_equipment_line'
                                                        : 'checkout.summary_step____aftermarket_equipment____enable_equipment_line'
                                                    ) | translate
                                                "
                                            ></app-button>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                            <ng-container *ngIf="!cd.offer?.closedOnExchangePrice">
                                <div *ngIf="checkoutService.aftermarketEquipmentData$ | async as amed" class="unstyled-table__row" role="row">
                                    <div class="unstyled-table__cell" role="cell">
                                        {{ 'checkout.summary_step____aftermarket_equipment____in_total' | translate }}
                                    </div>

                                    <div *ngIf="!!(breakpointService.matchBreakpoint(1024) | async)" class="unstyled-table__cell" role="cell"></div>
                                    <div class="unstyled-table__cell" role="cell">{{ amed.equipmentTotalPrice | defaultcurrency }}</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </section>
            </ng-container>
        </ng-container>
    `,
})
export class AftermarketEquipmentComponent {
    constructor(public checkoutService: CheckoutService, public breakpointService: BreakpointService) {}

    handleClick(allEquipment: IAtermarketEquipment[], equipmentToUpdate: IAtermarketEquipment, newEnableState: boolean) {
        this.checkoutService.setEquipment(
            allEquipment.map((e) =>
                e.id === equipmentToUpdate.id
                    ? {
                          ...equipmentToUpdate,
                          enabled: newEnableState,
                      }
                    : e
            )
        );
    }
}
